<template>
  <div class="history contents" v-if="localCoupon.purchaseProductId">
    <div class="view">
      <div class="header">
        <h1>{{ $t('cancel.confirm_withdrawal') }}</h1>
      </div>
      <!-- <div class="header cellphone">
        <h1>1:1 문의 접수</h1>
        <p class="violet">지난달 결제한 휴대폰 결제의 경우 결제취소가 불가능합니다.</p>
        <p>청약철회 신청을 하시면 자동으로 1:1 문의가 접수됩니다.<br>청약철회 신청을 하신 후 1:1 문의 답변을 통해 환불을 위한 필요서류 및 절차 확인해주세요</p>
      </div> -->
      <ul class="listTypeCart">
        <li class="productItem">
          <div class="productWrap">
            <div class="productDeco">
              <span class="productImg">
                <img
                  :src="localCoupon.imageUrl"
                  width="100%"
                  height="100%"
                  alt=""
                />
              </span>

              <span class="productName">{{ localCoupon.productName }}</span>
              <span class="productGame">{{ localCoupon.serviceName }}</span>
              <span class="productPrice">
                {{
                  $t('common.unit_and_value', {
                    value: localCoupon.price.addComma(),
                    unit: localCoupon.currencyUnit
                  })
                }}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="payInfo">
      <h2 class="subTitle">{{ $t('cancel.refund_details') }}}</h2>
      <div>
        <dl>
          <dt>{{ $t('cancel.payment_method') }}</dt>
          <dd>{{ localCoupon.paymentTypeName }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('cancel.expected_refund_amount') }}</dt>
          <dd>
            {{ localCoupon.price.addComma() }}{{ localCoupon.currencyUnit }}
          </dd>
        </dl>
      </div>
    </div>
    <ul class="msg">
      <li>{{ $t('cancel.coupon_retrieved_immediately') }}</li>
      <li>{{ $t('cancel.withdrawal_history') }}</li>
    </ul>
    <div class="bt">
      <button type="button" class="button53" @click="$router.back()">
        {{ $t('cancel.cancel') }}
      </button>
      <!-- <button
        type="button"
        class="button52"
      >청약철회</button> -->
      <button type="button" class="button52" @click="reqCancel">
        {{ $t('cancel.request_withdrawal') }}
      </button>
    </div>
  </div>
</template>

<script>
import MyAPI from '@/api/my'
import { mapActions } from 'vuex'
import { convertPaymentType } from '@/utils'

export default {
  props: {
    couponId: {
      type: Number,
      default: -1
    },
    coupon: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localCoupon: this.coupon
    }
  },
  computed: {
    paymentType() {
      return convertPaymentType(this.localCoupon.paymentType)
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('my', ['getCouponUsableList']),
    reqCancel() {
      this.openModal({
        type: 'confirm',
        message: this.$t('alert.request_withdrawal_confirmation'),
        callback: () => {
          MyAPI.reqCancelOrder(this.couponId, responseData => {
            if (responseData.code === 0) {
              this.getCouponUsableList(true) // 사용가능 쿠폰 목록 재호출
              this.openModal({
                type: 'alert',
                message: this.$t('alert.confirm_request_withdrawal'),
                callback: () => {
                  this.$router.replace({ name: 'coupon-usable' })
                }
              })
            }
          })
        }
      })
    }
  },
  mounted() {
    if (this.localCoupon.hasOwnProperty('purchaseProductId') === false) {
      MyAPI.getCouponDetail(this.couponId, responseData => {
        this.localCoupon = responseData.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.history {
  .header {
    padding: 0 16px 15px;
    border-bottom: 1px solid #d6d6db;
    h1 {
      margin: 0;
      padding: 29px 0 15px;
      font-size: 17px;
      text-align: center;
    }
    p {
      font-size: 12px;
      line-height: 15px;
    }
    p + p {
      margin-top: 6px;
    }
    .violet {
      color: #6134f1;
    }
  }
  .cellphone {
    h1 {
      padding: 21px 0 17px;
    }
  }
  .payInfo {
    position: relative;
    dd {
      font-size: 13px;
    }
    dl:nth-child(2) {
      dd {
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
  .bt {
    width: 100%;
    padding: 10px 10px 0;
    // height: 64px; safeArea
    button {
      border-radius: 4px;
      span {
        font-weight: bold;
      }
    }
    .button51,
    .button52,
    .button53 {
      width: calc(50% - 3px);
      margin-right: 6px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
